/**
 * historialMock.js
 *
 * Historial global de eventos (todos los activos, tipos y scopes) con
 * filtros + paginación, mientras el backend no esté disponible.
 *
 * Forma de la respuesta = backend real:
 *   {
 *     data: [ { id, scope, event_type, asset_type_slug, asset_nombre,
 *               referencia, asset_id, user_nombre, creator_nombre,
 *               motivo, created_at } ],
 *     pagination: { page, pageSize, total },
 *     counts: { todos, interno, colab }
 *   }
 */

const TIPOS = [
  { slug: 'coche', nombre: 'Coche', scope: 'interno', prefix: 'CH', modelos: ['Seat Toledo', 'BMW Serie 1', 'Audi Q3'] },
  { slug: 'portatil', nombre: 'Portátil', scope: 'interno', prefix: 'PT', modelos: ['MacBook Pro 14"', 'Lenovo ThinkPad X1', 'Dell Latitude'] },
  { slug: 'movil', nombre: 'Móvil', scope: 'colab', prefix: 'MVC', modelos: ['iPhone 14', 'Samsung A54'] },
  { slug: 'visa', nombre: 'VISA', scope: 'colab', prefix: 'VS', modelos: ['Tarjeta corporativa'] },
];

const EVENTOS = [
  'compra', 'asignacion', 'devolucion', 'reparacion_inicio',
  'reparacion_fin', 'baja', 'reactivacion', 'edicion',
];
const PERSONAS = [
  'Iban Lopetegi', 'Nagore Martín', 'Aitor Esnal', 'Alberto Fabeiro',
  'Lucía Sanz', 'Marta Ibáñez', 'Jon Aranzabal',
];
const REGISTRA = ['Iban L.', 'Nagore M.', 'Sistema'];

function pick(a, i) {
  return a[i % a.length];
}

// Genera un histórico determinista de N eventos
function build(n = 219) {
  const rows = [];
  const base = new Date('2026-05-15T18:00:00');
  for (let i = 0; i < n; i++) {
    const tipo = pick(TIPOS, i * 3 + (i % 4));
    const ev = pick(EVENTOS, i + (i % 5));
    const asignable = ev === 'asignacion' || ev === 'devolucion';
    const d = new Date(base.getTime() - i * 3.4 * 3600 * 1000);
    const assetId = (i % 12) + 1;
    rows.push({
      id: 9000 - i,
      scope: tipo.scope,
      event_type: ev,
      asset_type_slug: tipo.slug,
      asset_nombre: `${tipo.nombre} · ${pick(tipo.modelos, i)}`,
      referencia: `${tipo.prefix}-${String(assetId).padStart(4, '0')}`,
      asset_id: assetId,
      user_nombre: asignable ? pick(PERSONAS, i) : ev === 'compra' ? null : pick(PERSONAS, i + 2),
      creator_nombre: pick(REGISTRA, i),
      motivo:
        ev === 'baja' ? 'Fin de vida útil'
          : ev === 'reparacion_inicio' ? 'Avería detectada'
          : null,
      created_at: d.toISOString(),
      fecha: d.toISOString().slice(0, 10),
    });
  }
  return rows;
}

let _all = null;
function all() {
  if (!_all) _all = build(219);
  return _all;
}

export function mockListHistorial({
  scope, event_type, slug, search, from, to, page = 1, pageSize = 25,
}) {
  let rows = [...all()];

  if (scope && scope !== 'todos') rows = rows.filter((r) => r.scope === scope);
  if (event_type) rows = rows.filter((r) => r.event_type === event_type);
  if (slug) rows = rows.filter((r) => r.asset_type_slug === slug);
  if (from) rows = rows.filter((r) => r.created_at >= from);
  if (to) rows = rows.filter((r) => r.created_at <= `${to}T23:59:59`);
  if (search) {
    const q = String(search).toLowerCase();
    rows = rows.filter((r) =>
      [r.referencia, r.asset_nombre, r.user_nombre, r.motivo, r.creator_nombre]
        .some((v) => v && String(v).toLowerCase().includes(q))
    );
  }

  rows.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  const allRows = all();
  const counts = {
    todos: allRows.length,
    interno: allRows.filter((r) => r.scope === 'interno').length,
    colab: allRows.filter((r) => r.scope === 'colab').length,
  };

  const total = rows.length;
  const start = (Number(page) - 1) * Number(pageSize);
  return {
    data: rows.slice(start, start + Number(pageSize)),
    pagination: { page: Number(page), pageSize: Number(pageSize), total },
    counts,
    // Para el export: todos los filtrados (sin paginar)
    _allFiltered: rows,
  };
}

export const TIPOS_DISPONIBLES = TIPOS.map((t) => ({ slug: t.slug, nombre: t.nombre }));
export const EVENT_TYPES = EVENTOS;
